import { PromotionsApi } from '../clients';
import { mapPromotion } from '../mappers';

export const getPromotions = async () => {
  const data = await PromotionsApi.getPromotions();
  // Paginated envelope: { response: [...], total, page, limit }.
  const list = Array.isArray(data) ? data : data?.response ?? [];

  return list.map(mapPromotion);
};
